import { queryClient } from "@/queryClient"

type UnpairTerminalParams = {
  serialNumber: string
}

type UnpairTerminalResponse = {
  serialNumber: string
  clientName: string | null
  clientMid: string | null
}

export const unpairTerminal = async (
  params: UnpairTerminalParams
) => {
  const { body } = await api.post<UnpairTerminalResponse>(
    "/terminals/unpair/",
    { body: params }
  )

  queryClient.invalidateQueries({
    queryKey: [TERMINALS_QUERY_KEY],
  })

  return body
}
